const initialState = {
  message: '',
  severity: 'warning',
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_SNACKBAR':
      return {
        ...state,
        message: action.payload.message,
        severity: action.payload.severity,
        show: true
      };
    case 'CLOSE_SNACKBAR':
      return { ...state, message: '', show: false };
    default:
      return state;
  }
}
